/* eslint-disable react-hooks/exhaustive-deps */
import {
  Flex,
  Input,
  Radio,
  Select,
  Spin,
  Switch,
  Tooltip,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { SettingOutlined, InfoCircleOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import SaveButton from "../UI/savebutton";
import ProvidersTags from "../ProvidersTags";
import {
  fetchSTTechnicians,
  updateOrganization,
} from "../../redux/organizationSlice";
import { filterOption } from "../../utils/filterOption";
import { exclusiveWeekendOrgs } from "../../utils/constants";
import CustomCssTransition from "../UI/CustomCssTransition/customCssTransition";

const { Title } = Typography;

function JobSettings() {
  const [defaultDispatchText, setDefaultDispatchText] = useState({
    header: "",
    body: "",
    checkbox: "",
  });
  const [weekendDispatchText, setWeekendDispatchText] = useState("");

  const [tagIds, setTagIds] = useState([]);
  const [job_assigning_technican_id, setJobAssigningTechnicanId] =
    useState("No Selection");
  const [preventNoOwnership, setPreventNoOwnership] = useState(false);
  const [jobBookingFlowInfo, setJobBookingFlowInfo] = useState("pin_notes");
  const [includeCustomerJourney, setIncludeCustomerJourney] = useState(false);
  const [includeStatusForCustomerResidence, setIncludeStatusForCustomerResidence] = useState(false);

  const [isDirty, setIsDirty] = useState(false);
  const [showWeekend, setShowWeekend] = useState(false);

  const {
    loading,
    organizationData,
    serviceTitanTechnicians,
  } = useSelector((state) => state?.organization);

  const dispatch = useDispatch();

  useEffect(() => {
    setDefaultDispatchText({
      header: organizationData?.default_dispatch_header ?? "",
      body: organizationData?.default_dispatch_body ?? "",
      checkbox: organizationData?.default_dispatch_text ?? "",
    });
    setWeekendDispatchText(organizationData?.weekend_dispatch_text ?? "");
    setShowWeekend(organizationData?.showWeekend ?? false);
    setPreventNoOwnership(organizationData?.preventNoOwnership ?? false);
    setJobAssigningTechnicanId(
      organizationData?.job_assigning_technican_id ?? "No Selection"
    );
    setTagIds(organizationData?.tagIds || []);
    setJobBookingFlowInfo(organizationData?.jobBookingFlowInfo ?? "pin_notes");
    setIncludeCustomerJourney(organizationData?.includeCustomerJourney ?? false);
    setIncludeStatusForCustomerResidence(organizationData?.includeStatusForCustomerResidence ?? false);
    dispatch(fetchSTTechnicians(organizationData?._id || ""));
  }, [organizationData]);

  const onHeaderChange = (e) => {
    setDefaultDispatchText({
      ...defaultDispatchText,
      [e.target.name]: e.target.value,
    });
    setIsDirty(true);
  };

  const handleSubmit = () => {
    const { header, body, checkbox } = defaultDispatchText;
    let updateOrganizationData = {
      ...organizationData,
      job_assigning_technican_id: job_assigning_technican_id,
      preventNoOwnership: preventNoOwnership,
      tagIds: organizationData?.organization_provider === 'HCP'
        ? tagIds.map(tag => tag.toString())
        : tagIds,
      default_dispatch_header: header,
      default_dispatch_body: body,
      default_dispatch_text: checkbox,
      showWeekend: showWeekend,
      weekend_dispatch_text: weekendDispatchText,
      jobBookingFlowInfo: jobBookingFlowInfo,
      includeCustomerJourney: includeCustomerJourney,
      includeStatusForCustomerResidence: includeStatusForCustomerResidence,
    };

    dispatch(
      updateOrganization({
        id: organizationData._id,
        payload: updateOrganizationData,
        page: "Job Settings"
      })
    );
    setIsDirty(false);
  };

  const handleWeekendToggle = (checked) => {
    setShowWeekend(checked);
    setIsDirty(true);
  };

  const TechniciansList = [
    {
      label: "No Selection",
      value: "No Selection",
    },
    ...(serviceTitanTechnicians
      ?.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      })
      ?.filter((items) => items?.label) || []),
  ];
  return (
    <div className="w-full flex flex-col">
      <Spin spinning={loading} fullscreen />
      <Flex align="center" gap={10} style={{ marginBottom: "20px" }}>
        <SettingOutlined style={{ fontSize: 20 }} />
        <Title level={3} style={{ margin: 0, color: "black" }}>
          Job Settings
        </Title>
      </Flex>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 mb-4">
        {/* Left Column */}
        <div className="flex flex-col gap-4">
          <div className="bg-white shadow-md rounded-lg p-6 flex flex-col" style={{ minHeight: "400px" }}>
            <Title level={4} style={{ color: "#333", marginBottom: "16px" }}>
              {organizationData?.organization_provider === 'HCP' ? 'Default Service Text' : 'Default Dispatch Text'}
            </Title>

            <div className="flex flex-col gap-4 flex-1 justify-between">
              <div className="flex flex-col items-start gap-2">
                <label style={{ fontWeight: "bold" }}>Header</label>
                <Input
                  showCount
                  maxLength={100}
                  name="header"
                  value={defaultDispatchText?.header}
                  onChange={onHeaderChange}
                  placeholder="Enter header text"
                  size="large"
                  style={{ width: "100%" }}
                />
              </div>

              <div className="flex flex-col items-start gap-2">
                <label style={{ fontWeight: "bold" }}>Body</label>
                <TextArea
                  maxLength={250}
                  name="body"
                  value={defaultDispatchText?.body}
                  onChange={onHeaderChange}
                  placeholder="Enter body text"
                  size="large"
                  autoSize={{
                    minRows: 2,
                    maxRows: 4,
                  }}
                  showCount
                  style={{ width: "100%" }}
                />
              </div>

              <div className="flex flex-col items-start gap-2">
                <label style={{ fontWeight: "bold" }}>Checkbox</label>
                <Input
                  showCount
                  maxLength={25}
                  name="checkbox"
                  value={defaultDispatchText?.checkbox}
                  onChange={onHeaderChange}
                  placeholder="Enter checkbox text"
                  size="large"
                  style={{ width: "100%" }}
                />
              </div>

              {exclusiveWeekendOrgs.includes(organizationData?._id) && (
                <>
                  <div className="flex items-center justify-between w-full pt-2 border-t border-gray-200 mt-2">
                    <label style={{ fontWeight: "bold" }}>
                      {organizationData?.organization_provider === 'HCP' ? 'Enable Weekend Service Fee' : 'Enable Weekend Dispatch Fee'}
                    </label>
                    <Switch checked={showWeekend} onChange={handleWeekendToggle} />
                  </div>

                  <CustomCssTransition
                    in={showWeekend}
                    timeout={300}
                    classNames="glimpse"
                    unmountOnExit
                  >
                    <div className="flex flex-col items-start gap-2">
                      <label style={{ fontWeight: "bold" }}>
                        {organizationData?.organization_provider === 'HCP' ? 'Weekend Service Text' : 'Weekend Dispatch Text'}
                      </label>
                      <Input
                        showCount
                        maxLength={200}
                        name="text"
                        value={weekendDispatchText}
                        onChange={(e) => {
                          setWeekendDispatchText(e.target.value);
                          setIsDirty(true);
                        }}
                        placeholder="Enter weekend text"
                        size="large"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </CustomCssTransition>
                </>
              )}
            </div>
          </div>

          {organizationData?.organization_provider !== 'HCP' && (
            <div className="bg-white shadow-md rounded-lg p-6 flex flex-col" style={{ minHeight: "400px" }}>
              <Title level={4} style={{ color: "#333", marginBottom: "16px" }}>
                Booking Flow Settings
              </Title>

              <div className="flex flex-col gap-4">
                <div className="flex items-center gap-2">
                  <label style={{ fontWeight: "bold" }}>
                    Customer Job Booking Flow Information
                  </label>
                  <Tooltip
                    title="This determines where customer booking information will appear in ServiceTitan - either in Pin Notes, Job Summary section, or both locations"
                    placement="top"
                  >
                    <InfoCircleOutlined className="text-gray-400 hover:text-gray-600 cursor-help" />
                  </Tooltip>
                </div>

                <Radio.Group
                  value={jobBookingFlowInfo}
                  onChange={(e) => {
                    setJobBookingFlowInfo(e.target.value);
                    setIsDirty(true);
                  }}
                  style={{ width: "100%" }}
                >
                  <div className="flex flex-col gap-3">
                    <div className={`border rounded-lg p-4 transition-all duration-200 cursor-pointer ${jobBookingFlowInfo === 'pin_notes'
                        ? 'border-blue-400 bg-blue-50'
                        : 'border-gray-200 bg-gray-50 hover:border-blue-300 hover:bg-blue-25'
                      }`}>
                      <Radio value="pin_notes" className="w-full">
                        <div className="ml-2">
                          <div className="font-medium text-gray-800">Pin Notes</div>
                          <div className="text-sm text-gray-500 mt-1">Information will be pinned in the job notes section</div>
                        </div>
                      </Radio>
                    </div>

                    <div className={`border rounded-lg p-4 transition-all duration-200 cursor-pointer ${jobBookingFlowInfo === 'job_summary'
                        ? 'border-blue-400 bg-blue-50'
                        : 'border-gray-200 bg-gray-50 hover:border-blue-300 hover:bg-blue-25'
                      }`}>
                      <Radio value="job_summary" className="w-full">
                        <div className="ml-2">
                          <div className="font-medium text-gray-800">Job Summary</div>
                          <div className="text-sm text-gray-500 mt-1">Information will appear in the job summary section</div>
                        </div>
                      </Radio>
                    </div>

                    <div className={`border rounded-lg p-4 transition-all duration-200 cursor-pointer ${jobBookingFlowInfo === 'both'
                        ? 'border-blue-400 bg-blue-50'
                        : 'border-gray-200 bg-gray-50 hover:border-blue-300 hover:bg-blue-25'
                      }`}>
                      <Radio value="both" className="w-full">
                        <div className="ml-2">
                          <div className="font-medium text-gray-800">Both</div>
                          <div className="text-sm text-gray-500 mt-1">Information will appear in both places</div>
                        </div>
                      </Radio>
                    </div>
                  </div>
                </Radio.Group>

                <div className="flex items-center justify-between w-full pt-4 pb-1 border-t border-gray-200">
                  <div className="flex flex-col">
                    <label style={{ fontWeight: "bold" }}>
                      Include Customer Journey
                    </label>
                    <span className="text-sm text-gray-500 mt-1">
                      When enabled, the customer's journey information will be included in the job notes
                    </span>
                  </div>
                  <Switch
                    checked={includeCustomerJourney}
                    onChange={(checked) => {
                      setIncludeCustomerJourney(checked);
                      setIsDirty(true);
                    }}
                  />
                </div>

                <div className="flex items-center justify-between w-full pt-4 pb-1 border-t border-gray-200">
                  <div className="flex flex-col">
                    <label style={{ fontWeight: "bold" }}>
                      Include Home Ownership Status
                    </label>
                    <span className="text-sm text-gray-500 mt-1">
                      When enabled, the customer's home ownership status will be included in the job notes
                    </span>
                  </div>
                  <Switch
                    checked={includeStatusForCustomerResidence}
                    onChange={(checked) => {
                      setIncludeStatusForCustomerResidence(checked);
                      setIsDirty(true);
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Right Column */}
        <div className="flex flex-col gap-4">
          <div className="bg-white shadow-md rounded-lg p-6 flex flex-col" style={{ minHeight: "400px" }}>
            <Title level={4} style={{ color: "#333", marginBottom: "16px" }}>
              Job Configuration
            </Title>

            <div className="flex flex-col gap-4">
              <div className="flex flex-col items-start gap-2">
                <label style={{ fontWeight: "bold" }}>Job Tags</label>
                <div style={{ width: "100%" }}>
                  <ProvidersTags
                    tagIds={tagIds}
                    onTagChange={(value) => {
                      setTagIds([...value]);
                      setIsDirty(true);
                    }}
                    loading={loading}
                  />
                </div>
              </div>

              <div className="flex flex-col items-start gap-2">
                <label style={{ fontWeight: "bold" }}>
                  Assign Default Technician
                </label>
                <Select
                  style={{ width: "100%" }}
                  showSearch
                  value={job_assigning_technican_id}
                  onChange={(value) => {
                    setJobAssigningTechnicanId(value);
                    setIsDirty(true);
                  }}
                  options={TechniciansList}
                  filterOption={filterOption}
                  size="large"
                />
              </div>

              <div className="flex items-center justify-between w-full">
                <label style={{ fontWeight: "bold" }}>
                  Disallow Non-Home Owners From Booking Jobs
                </label>
                <Switch
                  checked={preventNoOwnership}
                  onChange={(value) => {
                    setPreventNoOwnership(value);
                    setIsDirty(true);
                  }}
                />
              </div>
            </div>
          </div>

        </div>
      </div>

      <SaveButton onSubmit={handleSubmit} isDirty={isDirty} />
    </div>
  );
}

export default JobSettings;
